import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { useStoreActions } from '../store/actions';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import cls from '../styles/Apartments.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface Type {
  [x: string]: {
    rooms: string;
    square: string;
  };
}

const apartments: Type = {
  '1': {
    rooms: '2',
    square: '66.79'
  },
  '2': {
    rooms: '1',
    square: '51.17'
  },
  '3': {
    rooms: '2',
    square: '67.06'
  },
  '4': {
    rooms: '3',
    square: '97.14'
  },
  '5': {
    rooms: '3',
    square: '92.45'
  },
  '6': {
    rooms: '1',
    square: '50.66'
  },
  '7': {
    rooms: '2',
    square: '80.96'
  },
  '8': {
    rooms: '3',
    square: '85.94'
  },
  '9': {
    rooms: '3',
    square: '82.11'
  },
  '10': {
    rooms: '1',
    square: '40.97'
  },
};

const Apartments = () => {
  const {
    incrementSelectedFloor,
    decrementSelectedFloor,
    onHoverOverApartment,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor, selectedApartment } = useSnapshot(AppStore);

  return (
    <div className={cls.mainContainer}>
      <div onClick={() => goPrevPage(10)} className={cls.mobileNavigationButton}>
        <img src="./images/arrow.png" alt="" />
        <p>К выбору этажа</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={incrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.imageWrapper}>
            <LazyLoadImage
              src={`./images/apartments/${selectedApartment}.png`}
              alt=""
              effect="blur"
            />
          </div>

          <div className={cls.textWrapper}>
            <p>{apartments[selectedApartment].rooms}-комнатные</p>

            <div className={cls.detailItem}>
              <div>Объект:</div>
              <div>«Испанский дом»</div>
            </div>

            <div className={cls.detailItem}>
              <div>Площадь квартиры:</div>
              <div>{apartments[selectedApartment].square} кв.м</div>
            </div>

            <div className={cls.detailItem}>
              <div>Адрес:</div>
              <div>Бишкек, мкрн Асанбай</div>
            </div>
          </div>
        </div>
      </div>

      <div className={cls.imageContainer}>
        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/2-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(1)}
                d="M 315.78418,371.35967V 266.01715 H 463.63763V 387.81146 H 315.78418Z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/1-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(2)}
                d="m 468.80084,256.75842h 103.38332 v 4.59964h -0.87893 v 127.71572h -72.00317 v -1.19519h -30.50122 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/2-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(3)}
                d="M 576.33092,394.43725V 266.04902 H 621.5619V 521.09347 H 520.27364V 394.43725 Z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/3-4">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(4)}
                d="M 634.82053,374.11002V 184.35017 H 609.61002V 87.960723 H 736.40906V 260.7721 H 690.9466v 113.33792 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/3-3">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(5)}
                d="M 869.3325,87.997765V 285.57044 H 742.26003V 87.997765 Z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/1-3">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(6)}
                d="M 721.95776,388.67539V 290.6783 h 137.622v 97.99709 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/2-3">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(7)}
                d="M 721.94182,394.09358H 859.5957 v 107.18453h 9.83242 v 46.63403h -147.4863 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/3-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(8)}
                d="M 741.47918,553.05368H 869.30063 V 737.44575H 741.47918 Z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/3-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(9)}
                d="M 606.50252,737.43147V 551.73101 h 79.1215v 50.46884 h 50.96534v 135.23162 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-ispanskiy-dom/1-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(10)}
                d="m 315.89686,521.02586v -15.663 h 3.20021v -61.07444 h -3.17767v -49.71595 h 59.99268v 29.57612 h 39.07863v 96.87727 z"
              />
            </a>
          </svg>

          <LazyLoadImage
            src="./images/floors/floor.png"
            alt=""
            effect="blur"
            placeholderSrc='./images/placeholder/floor.png'
          />
        </div>

        <div onClick={() => goPrevPage(10)} className={cls.navigationButton}>
          <img src="./images/arrow.png" alt="" />
          <p>К выбору этажа</p>
        </div>
      </div>
    </div >
  );
};

export default Apartments;
